// What the recipient's phone shows for the notification being edited:
// sender name on top, the text with sample values. The phone (csms-phone*)
// is the preview and stays as is; the caption below says what it shows.

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '../../design/ui';
import { smsLength } from './api';

const SmsPreview = ({ sender, eventLabel, text, enabled }) => {
  const { t } = useTranslation();
  const { chars, parts, unicode } = smsLength(text);
  return (
    <figure className="csms-phone" aria-label={t('customerSms.preview.label', 'Aperçu du SMS')}>
      <div className="csms-phone-screen">
        <div className="csms-phone-top">
          <span className="csms-phone-avatar" aria-hidden="true">{(sender || '?').slice(0, 1).toUpperCase()}</span>
          <strong className="csms-phone-sender">{sender}</strong>
        </div>
        <div className="csms-phone-thread">
          <span className="csms-phone-time">{t('customerSms.preview.now', "Aujourd'hui")}</span>
          <p className="csms-phone-bubble">{text}</p>
        </div>
      </div>
      <figcaption className="sms-v2__caption">
        <span className="sms-v2__caption-title">
          <strong>{eventLabel}</strong>
          {!enabled && <Badge>{t('channelsUi.sms.off', 'Désactivée')}</Badge>}
        </span>
        <span className="u-num">
          {t('customerSms.events.length', '{{chars}} caractères · {{parts}} SMS', { chars, parts })}
          {unicode ? ` · ${t('customerSms.preview.unicode', 'Unicode')}` : ''}
        </span>
        <span>{t('customerSms.preview.samples', "Valeurs d'exemple ; le vrai SMS reprend celles du colis.")}</span>
      </figcaption>
    </figure>
  );
};

export default SmsPreview;
